<template>
    <!-- 燃梦集结 -->
    <div class="jieshao-page">
        <navBar title="燃梦集结卡会员权益介绍" @onClickLeft="handleBack">
            <template slot="nav-left">
                <div></div>
            </template>
        </navBar>
        <img :src="`https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/dream/1-${item}.jpg`" v-for="item in 3" :key="item" alt="">
        <div class="last-img">
            <img :src="`https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-h5/entityCard/dream/1-${isOld?4:5}.jpg`">
            <div v-if="!isOld" class="btn needCopyBtn" @click="handleCopy('wd20221201')"></div>
        </div>
    </div>
</template>
<script>
import navBar from '../components/navBar.vue';
import {sensors, copyWechat} from '../minxins'
export default {
    components: {
        navBar,
    },
    mixins: [sensors, copyWechat],
    data() {
        return {
            isOld: this.$route.name === 'entityCardRightsJieshao1',
        }
    },
    methods: {
        handleBack() {
            this.$router.go(-1);
        }
    },
}
</script>

<style lang="less" scoped>
    @import '../asset/css/intro.less';
    .jieshao-page {
        background-color: #073A32;
    }
</style>